<template>
  <div>
    <v-skeleton-loader v-if="loading" type="card" />
    <v-card v-else class="rounded-lg" flat>
      <v-card-title class="px-10 pt-8">
        <p>High Risk</p>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-8">
        <div class="d-flex justify-space-between align-center">
          <p style="max-width: 1000px;">
            Marcar la organización como de alto riesgo insertará el snippet de
            país en todos los formularios y se activará la validación de ip con
            el país del usuario, buscando así que la ip recibida y el país
            seleccionado coincidan.
          </p>
          <v-switch v-model="high_risk" @change="toggleHighRisk" class="mb-2" />
        </div>
      </v-card-text>
      <v-divider />
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'organizationEnableHighRisk',
  data () {
    return {
      loading: false,
      high_risk: false
    }
  },
  async created () {
    this.loading = true
    await this.getOrganizationHighRisk()
    this.loading = false
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization
    })
  },
  methods: {
    ...mapActions({
      toggleHighRiskAction: 'organization/toggleHighRisk'
    }),
    async getOrganizationHighRisk () {
      this.high_risk = this.organization.high_risk
    },
    async toggleHighRisk () {
      try {
        await this.toggleHighRiskAction({
          orgId: this.organization.id,
          high_risk: this.high_risk
        })

        Vue.noty.success('High risk toggled successfully')
      } catch (error) {
        Vue.noty.error(`Error toggling high risk ${error.message}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
